/* UrlLink
* to change the UrlLink type add in the UrlLink prop: infotext ,without prop it's link underline text
*   <UrlLink to='/url' infotext>Terms of Service</UrlLink>
*   <UrlLink to='/url'>Forgot your password?</UrlLink> with underline text
*/
import React from 'react';
import { Link } from 'react-router-dom';
import classes from './UrlLink.module.css';

const urlLink = (props) => {
  let styles = props.infotext ? classes.Infotext : classes.UrlLink;
  const urlObj = { pathname: props.to };

  if (props.gaData) {
    urlObj.state = props.gaData;
  }

  return (
    <Link to={urlObj} className={styles} style={props.style}>
      {props.children}
    </Link>
  );
};
export default urlLink;



// WEBPACK FOOTER //
// ./src/components/UI/UrlLink/UrlLink.js